import { Gap } from 'component/Space/Gap'
import { Vertical } from 'component/Vertical'
import { observer } from 'mobx-react-lite'
import { ProfileForm } from 'page/ProfileScreen/ProfileForm/ProfileForm'
import { SaveButtonPane } from 'page/ProfileScreen/SaveButton/SaveButtonPane'

export const StandView = observer(() => {
  return (
    <Vertical minHeight="var(--page-viewport-height-simple)">
      <ProfileForm />
      <Gap spring height={32} />
      <SaveButtonPane />
    </Vertical>
  )
})
